export default __webpack_public_path__ + "static/media/collectible-final-epic.1f0547df.jpg";